<template>
  <div class="icon-manage-page">
    <div class="page-card">
      <!-- 统计卡片 -->
      <div class="stats-row">
        <div class="stat-card">
          <div class="stat-value">{{ totalCount }}</div>
          <div class="stat-label">图标总数</div>
        </div>
        <div class="stat-card used-card">
          <div class="stat-value used">{{ usedCount }}</div>
          <div class="stat-label">已使用</div>
        </div>
        <div class="stat-card unused-card">
          <div class="stat-value unused">{{ unusedCount }}</div>
          <div class="stat-label">未使用</div>
        </div>
      </div>

      <!-- 搜索栏 -->
      <div class="toolbar">
        <el-input
          v-model="searchKey"
          placeholder="搜索图标名称..."
          prefix-icon="el-icon-search"
          clearable
          class="search-input"
        />
        <el-radio-group v-model="filterType" size="small">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button label="used">已使用</el-radio-button>
          <el-radio-button label="unused">未使用</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 图标网格 -->
      <div v-if="filteredIcons.length" class="icon-grid">
        <div
          v-for="item in filteredIcons"
          :key="item.name"
          class="icon-item"
          @click="copyIcon(item)"
        >
          <div class="icon-preview-box">
            <svg-icon :icon-class="item.name" class="icon-img" />
          </div>
          <span class="icon-name">{{ item.name }}</span>
          <el-tag :type="item.isUsed ? 'success' : 'info'" size="mini" class="icon-tag">
            {{ item.isUsed ? '已使用' : '未使用' }}
          </el-tag>
        </div>
      </div>
      <div v-else class="empty-state">
        <i class="el-icon-search"></i>
        <p>未找到匹配的图标</p>
      </div>
    </div>
  </div>
</template>

<script>
import menuApi from '@/api/menu_setting'

function extractUsedIcons(menus) {
  const icons = new Set()
  function walk(list) {
    for (const item of list) {
      if (item.icon) icons.add(item.icon)
      if (item.children && item.children.length) walk(item.children)
    }
  }
  walk(menus)
  return icons
}

export default {
  name: 'IconManage',
  data() {
    return {
      searchKey: '',
      filterType: 'all',
      allIcons: []
    }
  },
  computed: {
    totalCount() {
      return this.allIcons.length
    },
    usedCount() {
      return this.allIcons.filter(i => i.isUsed).length
    },
    unusedCount() {
      return this.allIcons.filter(i => !i.isUsed).length
    },
    filteredIcons() {
      let list = this.allIcons
      if (this.filterType === 'used') {
        list = list.filter(i => i.isUsed)
      } else if (this.filterType === 'unused') {
        list = list.filter(i => !i.isUsed)
      }
      if (this.searchKey) {
        const kw = this.searchKey.toLowerCase()
        list = list.filter(i => i.name.toLowerCase().includes(kw))
      }
      return list
    }
  },
  mounted() {
    this.loadIcons()
  },
  methods: {
    async loadIcons() {
      try {
        const res = await menuApi.getMenuTree()
        const list = Array.isArray(res) ? res : Object.values(res || {})
        const usedIcons = extractUsedIcons(this.filterActiveMenus(list))
        const ctx = require.context('@/assets/icons/svg/', false, /\.svg$/)
        this.allIcons = ctx
          .keys()
          .map((key) => {
            const name = key.replace('./', '').replace('.svg', '')
            return { name, isUsed: usedIcons.has(name) }
          })
          .sort((a, b) => {
            if (a.isUsed !== b.isUsed) return a.isUsed ? -1 : 1
            return a.name.localeCompare(b.name)
          })
      } catch (e) {
        console.error('获取菜单树失败', e)
      }
    },
    filterActiveMenus(menus) {
      return menus
        .filter(item => String(item.status) === '1')
        .map(item => {
          const filteredChildren = item.children ? this.filterActiveMenus(item.children) : []
          if (item.children && item.children.length > 0 && filteredChildren.length === 0) {
            return null
          }
          return { ...item, children: filteredChildren }
        })
        .filter(Boolean)
    },
    copyIcon(item) {
      const code = `<svg-icon icon-class="${item.name}"></svg-icon>`
      const textarea = document.createElement('textarea')
      textarea.value = code
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success(`已复制: ${code}`)
      } catch (e) {
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    }
  }
}
</script>

<style scoped>
.icon-manage-page {
  min-height: 100%;
  background: #f0f2f5;
  padding: 24px;
}

.page-card {
  background: #fff;
  border-radius: 4px;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

/* 统计卡片 */
.stats-row {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.stat-card {
  flex: 1;
  text-align: center;
  padding: 20px 16px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
}

.stat-value {
  font-size: 32px;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
  margin-bottom: 8px;
}

.stat-value.used {
  color: #52c41a;
}

.stat-value.unused {
  color: #909399;
}

.stat-label {
  font-size: 14px;
  color: #909399;
}

/* 工具栏 */
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.search-input {
  width: 280px;
}

/* 图标网格 */
.icon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 8px 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background: #fff;
}

.icon-item:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
  transform: translateY(-1px);
}

.icon-preview-box {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  background: #fafafa;
  border-radius: 4px;
}

.icon-img {
  width: 32px;
  height: 32px;
}

.icon-name {
  font-size: 12px;
  color: #606266;
  margin-bottom: 8px;
  text-align: center;
  word-break: break-all;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 100%;
}

.icon-tag {
  flex-shrink: 0;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 0;
  color: #c0c4cc;
}

.empty-state i {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

.empty-state p {
  font-size: 14px;
  margin: 0;
}
</style>
